import React from "react";
import { useEditor } from "./EditorContext";

// Aba Estilos — mostra Selectors / Traits / StyleManager renderizados pelo
// GrapesJS. Adiciona empty state e um header com o nome do componente
// selecionado. Os containers seguem os mesmos IDs esperados pela config
// (`#selectors-container`, `#traits-container`, `#style-manager-container`).

const StylesPanel = ({ active }) => {
  const { selected } = useEditor();
  const hasSelection = !!selected;

  const compName =
    selected?.get?.("name") ||
    selected?.get?.("tagName") ||
    "Elemento";

  return (
    <div className={`v2-pane ${active ? "active" : ""}`} data-pane="styles">
      {hasSelection && (
        <div className="v2-selection-header">
          <i className="fa fa-cube v2-sel-icon" />
          <span className="v2-sel-name">{compName}</span>
        </div>
      )}

      {!hasSelection && (
        <div className="v2-empty-state">
          <div className="v2-empty-icon">
            <i className="fa fa-mouse-pointer" />
          </div>
          <div className="v2-empty-title">Nenhum elemento selecionado</div>
          <div className="v2-empty-hint">
            Clique em um elemento no canvas para editar seus estilos e
            configurações.
          </div>
        </div>
      )}

      <div
        className="v2-styles-host"
        style={{ display: hasSelection ? "block" : "none" }}
      >
        <div id="selectors-container" />
        <div id="traits-container" />
        <div id="style-manager-container" />
      </div>
    </div>
  );
};

export default StylesPanel;
